import { createResourceExplorerFolderSelector } from "../views-hierarchy/createResourceExplorerFolderSelector";
import { RootState } from "../../../store";

export const createResourceExplorerFolderLoadingSelector = (
  state: RootState,
): boolean => {
  return !!createResourceExplorerFolderSelector(state)?.isLoading;
};
